import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { COURSES, courseImg } from "@/lib/advancedCourses";

export const AdvancedCoursesBanner = () => {
  const { L } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-14" data-testid="home-advanced-courses-banner">
      <Reveal>
        <div className="rounded-3xl bg-white border border-slate-200 p-7 sm:p-10">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-[#E0F4F6] px-3 py-1 text-xs font-bold text-[#007A8A]"><GraduationCap className="w-3.5 h-3.5" />{L("New · Advanced Courses", "नया · एडवांस्ड कोर्स")}</span>
              <h2 className="mt-3 font-['Outfit'] font-black text-3xl sm:text-4xl text-[#0A192F]">{L("Quantum, Applied AI, Data Centres & more", "क्वांटम, एप्लाइड AI, डेटा सेंटर और बहुत कुछ")}</h2>
              <p className="mt-2 text-slate-600 max-w-xl">{L("7 industry-ready courses with module-wise syllabus, real projects and a free first lesson.", "7 इंडस्ट्री-रेडी कोर्स — मॉड्यूल-वार सिलेबस, असली प्रोजेक्ट और मुफ़्त पहला लेसन।")}</p>
            </div>
            <Link to="/advanced-courses" className="inline-flex items-center gap-2 rounded-full bg-[#0A192F] hover:bg-[#FF2E63] text-white px-6 py-3 font-bold transition-colors" data-testid="home-advanced-courses-link">{L("Explore courses", "कोर्स देखें")}<ArrowRight className="w-4 h-4" /></Link>
          </div>
          <div className="mt-6 flex gap-3 overflow-x-auto pb-2 snap-x">{COURSES.map((c) => (
            <Link key={c.id} to={`/advanced-courses/${c.id}`} className="group relative shrink-0 w-56 snap-start rounded-2xl overflow-hidden aspect-[4/3]" data-testid={`home-course-${c.id}`}>
              <img src={courseImg(c)} alt={c.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/90 to-transparent" />
              <span className="absolute bottom-3 left-3 right-3 text-white font-bold text-sm leading-snug">{c.title}</span>
            </Link>))}</div>
        </div>
      </Reveal>
    </section>
  );
};
